import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { PopupType } from './popup-type.enum';
import { PopupModalComponent } from './popup-modal.component';
import { PopupOptions } from './popup-options';
import { SharedModule } from '../../shared.module';
import { PlatformLocation } from '@angular/common';
import { PostLoginInterruptService } from '../../../core/services/post-login-interrupt/post-login-interrupt.service';

@Injectable({
  providedIn: SharedModule,
})
export class PopupService {
  defaultOptions: any = {
    centered: true,
    keyboard: false,
    backdropClass: 'backdrop-popup',
  };

  constructor(
    private modalService: NgbModal,
    private location: PlatformLocation,
    private interruptService: PostLoginInterruptService,
  ) {
    // P2P-28 · F0.3 — was a raw modalService.dismissAll(), which also dismissed the post-login
    // interrupt queue's own modal (single item or frame) on browser Back/Forward — bypassing
    // its backdrop:'static'/keyboard:false, since those only block USER-driven dismissal, not
    // a programmatic .dismiss() call. That let a mandatory gate get silently marked "deferred"
    // (settled, without acceptance) by pressing Back. dismissOtherModals() already exists for
    // exactly this — dismiss everything except whatever the interrupt queue currently owns —
    // and is what AppComponent's own NavigationEnd handler uses.
    this.location.onPopState(() => this.interruptService.dismissOtherModals());
  }

  alert(message: string, options?: PopupOptions, autoCloseDuration?: number): Promise<any> {
    return this.open(message, PopupType.alert, options, autoCloseDuration);
  }

  confirm(message: string, options?: PopupOptions): Promise<any> {
    return this.open(message, PopupType.confirm, options);
  }

  success(message: string, options?: PopupOptions): Promise<any> {
    return this.open(message, PopupType.success, options);
  }

  duplicate(message: string, options?: PopupOptions): Promise<any> {
    return this.open(message, PopupType.duplicate, options);
  }
  private open(
    message: string,
    popupType: PopupType,
    options: PopupOptions,
    autoCloseDuration?: number,
  ): Promise<any> {
    this.defaultOptions.backdrop = options && options.backdrop ? options.backdrop : 'static';
    const modalRef = this.modalService.open(PopupModalComponent, this.defaultOptions);
    modalRef.componentInstance.type = popupType;
    modalRef.componentInstance.message = message;

    if (options) {
      modalRef.componentInstance.titleLabel = options.titleLabel;
      modalRef.componentInstance.okLabel = options.okLabel;
      modalRef.componentInstance.cancelLabel = options.cancelLabel;
      modalRef.componentInstance.okClass = options.okClass;
      modalRef.componentInstance.cancelClass = options.cancelClass;
      modalRef.componentInstance.titleClass = options.titleClass;
      modalRef.componentInstance.showTitle = options.showTitle == null ? true : options.showTitle;
      modalRef.componentInstance.showIcon = options.showIcon == null ? true : options.showIcon;
    }
    //FRC-362 autoCloseDuration for close alert automatically
    if (autoCloseDuration) {
      setTimeout(() => {
        if (modalRef && typeof modalRef.close === 'function') {
          modalRef.close();
        }
      }, autoCloseDuration);
    }

    return modalRef.result;
  }
}
